import React, { useState, useEffect } from 'react';
import {hangboardsSource} from './hangboardsSource';
import { Hangboard, UsedHold } from './classes/Hangboard';
import hangboards from './hangboards.json';

interface IHangboardDisplayProps{
    callback?: Function;
    usedHolds?: number[];
    name: string;
    unclickable?: boolean;
}
export const HangboardDisplay =(props:IHangboardDisplayProps)=>{
    const selectedHangboard = hangboards.find(hangboard=> hangboard.name ==props.name);
    const [hangboardState, setHangboardState] = useState(new Hangboard({usedHolds: props.usedHolds, hangboard: selectedHangboard}));
    useEffect(()=>{
        if(hangboardState.name != props.name)
            setHangboardState((new Hangboard({hangboard: selectedHangboard})));
        },[props.name]
    );
  
    const handleClic=( id)=>{
        if (!props.unclickable) {
          if(props.callback){
            setHangboardState(()=>{
                hangboardState.handleClick(id);
                props.callback(hangboardState.usedHolds);
                return Object.assign(new Hangboard({usedHolds: hangboardState.usedHolds, hangboard: selectedHangboard}),hangboardState);
            });
          }
        }
    }
    const generateSVGS=()=>{
        if(props.name == hangboardState.name){
            return selectedHangboard.holds.map((hold, index)=>{
                return(
                    <svg key={index} height={hold.svg.height} width={hold.svg.width} x={hold.svg.x} y={hold.svg.y} onClick={() => handleClic(hold.id)} opacity={hangboardState.holds[hold.id].used ? 1:0}>
                        <rect height={hold.svg.rectHeight || hold.svg.height} width={hold.svg.rectWidth || hold.svg.width} rx={hold.svg.rx} ry={hold.svg.ry} transform={hold.svg.transform} fill="#E74C3C"/>
                    </svg>)});
        }
        return null
    }
    const hangboardSource = hangboardsSource.find(source=> source.name ==props.name).source;
    return(
        <svg version="1.1" id="Layer_1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 825 302" enableBackground="new 0 0 825 302" preserveAspectRatio="xMidYMid meet">  <image id="image0" width="825" height="302" x="0" y="0"
            href={hangboardSource} />
            {generateSVGS()}
        </svg>
    )
}